import { SupplyId } from '@wwf/sdk';

export const getLinkToSupply = (supplyId: SupplyId | undefined | null) => {
    if (!supplyId) return '';
    return `/supply?show=${supplyId}`;
};
